import "./SettingsMobile.css";
import { useState, useContext } from "react";
import { Helmet } from "react-helmet";
import rightArrow from "../../../../assets/right-arrow.png";
import profile from "../../../../assets/profile-2.png";
import man from "../../../../assets/man.png";
import Security from "./components/Security/Security";
import AddPayouts from "./components/Payouts/Payouts";
import Payouts from "../components/AddPayouts/AddPayouts";
import PersonalInformationMobile from "./components/PersonalInformation/PersonalInformationMobile";
import EditPersonalInformation from "../components/PersonalInfomation/EditPersonalInformation/EditPersonalInformation";
import Topbar from "./components/Topbar/Topbar";
import { UserContext } from "../../../context/UserContext";

const SettingsMobile = () => {
 const [active, setActive] = useState("settings");
 const { logOut } = useContext(UserContext);
 return (
  <>
   <Helmet>
    <title> Settings | Dashboard | SHAP</title>
    <meta
     name="description"
     content="Knowledge-based digital products distribution at a premium"
    />
   </Helmet>
   {active === "settings" && (
    <div className="settings-mobile-landing">
     <div className="profile">
      <div className="img-container">
       <img src={man} alt="profile" />
      </div>
      <div className="name-container">
       <p className="title">Nsikan Etukudoh</p>
       <p onClick={() => setActive("editpersonalinformation")}>Go to profile</p>
      </div>
     </div>
     <div className="item-container">
      <div className="item" onClick={() => setActive("personalinformation")}>
       <div>
        <img src={profile} alt="setting icon" />
        <p>Personal Information</p>
       </div>
       <img src={rightArrow} alt="right arrow" />
      </div>
      <div className="item" onClick={() => setActive("security")}>
       <div>
        <img src={profile} alt="setting icon" />
        <p>Security</p>
       </div>
       <img src={rightArrow} alt="right arrow" />
      </div>

      <div className="item" onClick={() => setActive("addpayouts")}>
       <div>
        <img src={profile} alt="setting icon" />
        <p>Payouts</p>
       </div>
       <img src={rightArrow} alt="right arrow" />
      </div>

      <div className="item" onClick={() => setActive("notifications")}>
       <div>
        <img src={profile} alt="setting icon" />
        <p>Notifications</p>
       </div>
       <img src={rightArrow} alt="right arrow" />
      </div>

      <div className="item" onClick={() => setActive("globalpreference")}>
       <div>
        <img src={profile} alt="setting icon" />
        <p>Global Preference</p>
       </div>
       <img src={rightArrow} alt="right arrow" />
      </div>
     </div>

     <p className="logout" onClick={logOut}>
      Logout
     </p>
    </div>
   )}

   {active === "personalinformation" && (
    <div className="settings-mobile-wrapper">
     <Topbar
      setActive={setActive}
      text="Personal Information"
      back="settings"
     />
     <PersonalInformationMobile setActive={setActive} />
    </div>
   )}

   {active === "editpersonalinformation" && (
    <div className="settings-mobile-wrapper">
     <Topbar
      setActive={setActive}
      text="Edit Personal Information"
      back="personalinformation"
     />
     <EditPersonalInformation setActive={setActive} />
    </div>
   )}

   {active === "addpayouts" && (
    <div className="settings-mobile-wrapper">
     <Topbar setActive={setActive} text="Payout Method" back="settings" />
     <AddPayouts setActive={setActive} />
    </div>
   )}

   {active === "addpayoutmethod" && (
    <div className="settings-mobile-wrapper">
     <Topbar setActive={setActive} text="Add Payout Method" back="addpayouts" />
     <Payouts setActive={setActive} />
    </div>
   )}

   {active === "security" && (
    <div className="settings-mobile-wrapper">
     <Topbar setActive={setActive} text="Security" back="settings" />
     <Security setActive={setActive} />
    </div>
   )}
  </>
 );
};

export default SettingsMobile;
